import { render, staticRenderFns } from "./ClientePesquisaAvancadaModal.vue?vue&type=template&id=2d797a52&scoped=true"
import script from "./ClientePesquisaAvancadaModal.vue?vue&type=script&lang=js"
export * from "./ClientePesquisaAvancadaModal.vue?vue&type=script&lang=js"
import style0 from "./ClientePesquisaAvancadaModal.vue?vue&type=style&index=0&id=2d797a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d797a52",
  null
  
)

export default component.exports